var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "uaa_content" },
    [
      _c(
        "el-header",
        {
          staticStyle: {
            height: "40px",
            "background-color": "rgb(46,117,181)",
            padding: "0"
          }
        },
        [_c("header_info")],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            {
              staticStyle: { "background-color": "#545c64" },
              attrs: { width: "200px" }
            },
            [_c("left_menu")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c(
                "el-container",
                [
                  _c(
                    "el-header",
                    { staticStyle: { height: "35px" } },
                    [_c("content_nav")],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-main", [_c("router-view")], 1)
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 